/**
 * @file: FeedMessageType.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 *
 * Mirrors `@zhichetech/models` FeedMessageType — keep in sync with
 * backend `packages/models/src/enum/FeedMessageType.ts`.
 */

export enum FeedMessageType {
  OrgTaskAssigned = 'org:task-assigned',
  OrgTaskStatusUpdate = 'org:task-status-update',
  OrgTaskFlowStatusUpdate = 'org:task-flow-status-update',
  OrgReworkRequest = 'org:rework-request',
  OrgNewOrder = 'org:new-order',
  OrgOrderInfoUpdated = 'org:order-info-updated',
  OrgReportShared = 'org:report-shared',
  OrgCustomerViewedReport = 'org:customer-viewed-report',
  OrgProductReferralRewardDeposited = 'org:product-referral-reward-deposited',
  OrgCampaignRewardDeposited = 'org:campaign-reward-deposited',
  OrgMemberAccountWithdraw = 'org:member-account-withdraw',
  OrgMaintenancePlanUpdated = 'org:maintenance-plan-updated',
  OrgMaintenancePlanSettingsChanged = 'org:maintenance-plan-settings-changed',
  OrgMaintenancePlanRemind = 'org:maintenance-plan-remind',
  OrgLeadRemind = 'org:lead-remind',
  OrgMarketingFollowup = 'org:marketing-followup',
  OrgCustomerCommentPosted = 'org:customer-comment-posted',
  OrgSystemAlert = 'org:system-alert',
  OrgGlobalMessage = 'org:global-message',
}

export enum FeedMessageAuthorType {
  System = 'system',
  OrgMember = 'org-member',
  OrgUser = 'org-user',
  PlatformUser = 'platform-user',
}

export enum FeedThreadScope {
  Order = 'order',
  Rewards = 'rewards',
  System = 'system',
  MaintenancePlans = 'maintenance-plans',
  Leads = 'leads',
  MarketingFollowup = 'marketing-followup',
}
